
import { BrowserRouter as Router, Switch, Route, withRouter } from "react-router-dom";
import { Suspense, useEffect, useState } from 'react';
import Home from "./pages/Home";
import Profile from "./pages/profile";
import Register from "./pages/register";
import ConfirmEmail from "./pages/confirm-email";
import Branchs from "./pages/branchList";
import Agents from "./pages/agentList";
import Layout from "./components/common/Layout";
import Banner from "./components/common/banner";
import { ProtectedRoute } from "./pages/protectRoute";
import httpClientInstants from './libs/utils/HttpClient';
import envInstants from './libs/config/env';
import { useDispatch, useSelector } from 'react-redux';
import { Provider } from 'react-redux';
import './styles/globals.css';
import store from './redux/store';
import { setDefaultURL } from "./libs/utils/axiosApiInstance";

// export function timeout(ms) {
//   return new Promise(resolve => setTimeout(resolve, ms));
// }


function App() {

  const [isInitEnvError, setInitEnvError] = useState(false);
  const [isInitEnv, setInitEnv] = useState(false);

  useEffect(() => {
    const loadEnv = async () => {
      try {
        // await timeout(3000);
        await envInstants.init();
        setDefaultURL(envInstants.getConfig().baseUrl);

        httpClientInstants.setBaseUrl(envInstants.getConfig().baseUrl);
      } catch (error) {
        setInitEnvError(true);
      } finally {
        setInitEnv(true);
      }
    };


    loadEnv();
  }, []);

  if (!isInitEnv) return "";
  if (isInitEnvError) return "Cannot load env !!!";

  return (
    <>
      <Suspense fallback="">
      <Provider store={store}>
        <Router>


          <Layout >
            <Switch>
              <Route exact path="/" component={Home} />
              <Banner>
                <Route path="/register" component={Register} />

                <ProtectedRoute  path="/profile" component={Profile} />
                {/* <Route path="/profile" component={Profile} />    */}
                <Route path="/confirm-email" component={ConfirmEmail} />
                <Route path="/branchs" component={Branchs} />
                <Route path="/agents" component={Agents} />
                {/* <Route path="*" exact={true} component={NotFound} /> */}
              </Banner>



            </Switch>
          </Layout>




        </Router>
        </Provider>
      </Suspense>
    </>


  );
}

export default withRouter(App);
